import { ChartLine } from 'lucide-react';
import { lazy } from 'react';
import { msg } from '@/lib/i18n';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityTab } from '../entityTabs';
import { defineModule } from '../types';
import { insightsKeys } from './api';
import { driversRoute, ecoRoute, groupsRoute, overviewRoute, vehiclesRoute } from './routes';

/** Insights (IA §2 Improve › Insights): fleet performance, rankings, eco, groups; entity Performance tabs. */
export const insightsModule = defineModule({
  key: 'insights',
  routes: [overviewRoute, driversRoute, vehiclesRoute, ecoRoute, groupsRoute],
  nav: [
    {
      key: 'insights',
      label: msg('Insights'),
      description: msg('Fleet performance: scores, trends and comparisons between groups, drivers and vehicles.'),
      icon: ChartLine,
      to: '/insights',
      section: 'improve',
      order: 40,
      module: 'insights',
      permission: 'insights.fleet.read',
      match: ['/insights'],
      children: [
        { key: 'drivers', label: msg('Drivers'), to: '/insights/drivers' },
        { key: 'vehicles', label: msg('Vehicles'), to: '/insights/vehicles' },
        { key: 'eco', label: msg('Eco and fuel'), to: '/insights/eco' },
        { key: 'groups', label: msg('Groups'), to: '/insights/groups' },
      ],
    },
  ],
  setup() {
    // Entity pages (IA §3): replaces fleet's "Performance" placeholders (same key, registered after fleet).
    registerEntityTab('vehicle', {
      key: 'performance',
      label: msg('Performance'),
      order: 30,
      permission: 'insights.fleet.read',
      module: 'insights',
      component: lazy(() => import('./tabs/VehiclePerformanceTab')),
    });
    registerEntityTab('driver', {
      key: 'performance',
      label: msg('Performance'),
      order: 30,
      permission: 'insights.fleet.read',
      module: 'insights',
      component: lazy(() => import('./tabs/DriverPerformanceTab')),
    });
    // A re-classification or a group change moves members between cohorts and groups.
    registerInvalidation('group', () => [insightsKeys.all]);
  },
});
